import * as React from "react";
import classnames from "classnames";
import { LocationSearch } from "@grandvisionhq/locations";
import { useIntl } from "@grandvisionhq/state";
import StoreFinderMapContainer from "../../../StoreFinderMap/components/StoreFinderMap/StoreFinderMapContainer.js";
import StoreListTopContent from "../../../StoreListTopContent/components/StoreListTopContent/StoreListTopContent.js";
import useStoreSearchFilters from "../../../../hooks/hooks/use-store-search-filters.js";
import { useTabs } from "../../../../hooks/hooks/use-tabs.js";
import { StoreFinderFilterWarning } from "../../../StoreFinderFilterWarning/components/StoreFinderFilterWarning/StoreFinderFilterWarning.js";
import StoreFinderItemContainer from "../../../StoreFinderItem/components/StoreFinderItem/StoreFinderItemContainer.js";
/* empty css                               */
import { useStoreFinderContext } from "../../../../context/StoreFinder/context/StoreFinder/context.js";
const StoreGroupFinderContainer = ({
  className,
  storeSearchFilters: propStoreSearchFilters,
  groupName,
  urls
}) => {
  const { getFormattedLabel } = useIntl();
  const { isPristineSearch, isStoresLoading, stores, config, setHoveredStore } = useStoreFinderContext();
  const [{ applyActiveFilters }, { hasActiveFilters, loading }] = useStoreSearchFilters({
    filters: propStoreSearchFilters
  });
  const { googleMapsId } = config;
  const showTabs = useTabs();
  const onMouseEnterHandler = React.useCallback(
    (store) => setHoveredStore(store),
    [setHoveredStore]
  );
  const onMouseLeaveHandler = React.useCallback(() => setHoveredStore(null), [setHoveredStore]);
  const filteredStores = React.useMemo(
    () => applyActiveFilters(stores),
    [stores, applyActiveFilters]
  );
  !isPristineSearch && !isStoresLoading && stores.length === 0;
  return /* @__PURE__ */ React.createElement(
    LocationSearch,
    {
      className: classnames("store-group-finder", className),
      googleMapsId,
      showTabs,
      searchForm: null,
      listTopContent: /* @__PURE__ */ React.createElement(
        StoreListTopContent,
        {
          className: "store-group-finder__list-top-content",
          title: getFormattedLabel(
            "stores.page.group.storeFinder.title",
            groupName ? {
              labelData: {
                groupName
              }
            } : void 0
          ),
          description: getFormattedLabel("stores.page.group.storeFinder.description", {
            hideLabelKey: true,
            labelData: {
              storeCount: stores.length
            }
          })
        }
      ),
      listInfoContent: /* @__PURE__ */ React.createElement(
        StoreFinderFilterWarning,
        {
          applyActiveFilters,
          hasActiveFilters
        }
      ),
      loadingListItems: isStoresLoading,
      listItems: filteredStores.map((store) => /* @__PURE__ */ React.createElement(
        StoreFinderItemContainer,
        {
          loading,
          key: store.globalStoreId,
          store,
          onMouseEnter: onMouseEnterHandler,
          onMouseLeave: onMouseLeaveHandler,
          urls,
          showAttributesAsTags: true
        }
      )),
      mapContent: /* @__PURE__ */ React.createElement(
        StoreFinderMapContainer,
        {
          stores: filteredStores,
          infoWindowContentComponent: (props) => /* @__PURE__ */ React.createElement(StoreFinderItemContainer, { ...props, urls, view: "map", showAttributesAsTags: true })
        }
      )
    }
  );
};
export {
  StoreGroupFinderContainer as default
};
//# sourceMappingURL=StoreGroupFinderContainer.js.map
